import React from 'react';
import DashboardLayout from '../../components/layout/DashboardLayout';
import { Card } from '../../components/ui/card';
import { Receipt } from 'lucide-react';

export default function PaymentHistoryPage() {
  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h1 className="text-2xl lg:text-3xl font-outfit font-bold text-slate-900">
            Payment History
          </h1>
          <p className="text-slate-500 mt-1">
            View your past transactions and invoices
          </p>
        </div>

        <Card className="p-12 text-center rounded-2xl border border-slate-100">
          <div className="w-16 h-16 bg-amber-50 rounded-2xl flex items-center justify-center mx-auto mb-4">
            <Receipt className="w-8 h-8 text-amber-400" />
          </div>
          <h3 className="text-lg font-semibold text-slate-700 mb-2">
            No Payment Records
          </h3>
          <p className="text-slate-500 text-sm max-w-sm mx-auto">
            Your payment history will appear here once you complete transactions.
          </p>
        </Card>
      </div>
    </DashboardLayout>
  );
}
